export const ANALYTICS_EVENTS = {
  // Auth
  LOGIN: 'login',
  LOGOUT: 'logout',
  SIGN_UP: 'sign_up',

  // Navigation
  PAGE_VIEW: 'page_view',

  // Studio
  STUDIO_CREATED: 'studio_created',
  STUDIO_UPDATED: 'studio_updated',
  STUDIO_DELETED: 'studio_deleted',

  // Production
  PRODUCTION_CREATED: 'production_created',
  PRODUCTION_UPDATED: 'production_updated',
  PRODUCTION_DELETED: 'production_deleted',

  // Episode
  EPISODE_CREATED: 'episode_created',
  EPISODE_UPDATED: 'episode_updated',
  EPISODE_DELETED: 'episode_deleted',

  // Set
  SET_CREATED: 'set_created',
  SET_UPDATED: 'set_updated',
  SET_DELETED: 'set_deleted',

  // Location
  LOCATION_CREATED: 'location_created',
  LOCATION_UPDATED: 'location_updated',
  LOCATION_DELETED: 'location_deleted',

  // Department
  DEPARTMENT_CREATED: 'department_created',

  // Store
  STORE_PAGE_VIEW: 'store_page_view',
  ORDERS_PAGE_VIEW: 'orders_page_view',
  VENDOR_DETAIL_VIEW: 'vendor_detail_view',
  PRODUCT_DETAIL_VIEW: 'product_detail_view',
  PACKAGE_DETAIL_VIEW: 'package_detail_view',
  SERVICE_DETAIL_VIEW: 'service_detail_view',

  // Cart / Order Flow
  ADD_TO_CART: 'add_to_cart',
  PREVIEW_SHIFT: 'preview_shift',
  CART_QUANTITY_UPDATED: 'cart_quantity_updated',
  CART_LOCATION_UPDATED: 'cart_location_updated',
  CART_SHIFT_UPDATED: 'cart_shift_updated',
  CART_ADD_MORE_ITEMS: 'cart_add_more_items',

  // Orders
  ORDER_PLACED: 'order_placed',
  ORDER_CANCELLED: 'order_cancelled',
  ORDER_SHIFTS_CANCELLED: 'order_shifts_cancelled',
  ORDER_RETURNED: 'order_returned',
  ORDER_SHIFT_UPDATED: 'order_shift_updated',
  ORDER_ADD_MORE_ITEMS: 'order_add_more_items',

  // Payment
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAILED: 'payment_failed',

  // Documents
  DOCUMENT_UPLOADED: 'document_uploaded',
  DOCUMENT_DOWNLOADED: 'document_downloaded',
  DOCUMENT_DELETED: 'document_deleted',

  // Risk
  RISK_DASHBOARD_VIEW: 'risk_dashboard_view',
  RISK_FORM_SUBMITTED: 'risk_form_submitted',
  RISK_THREAT_DETAIL_VIEW: 'risk_threat_detail_view',
  RISK_PDF_EXPORTED: 'risk_pdf_exported',

  // Contacts
  CONTACT_INVITED: 'contact_invited',
  CONTACT_REMOVED: 'contact_removed',

  // Invoices
  INVOICE_LISTING_PAGE_VIEW: 'invoice_listing_page_view',
  INVOICE_TAB_SWITCHED: 'invoice_tab_switched',
  INVOICE_REQUESTS_PAGE_VIEW: 'invoice_requests_page_view',
  INVOICE_REQUESTS_TAB_SWITCHED: 'invoice_requests_tab_switched',
  INVOICE_CARD_CLICKED: 'invoice_card_clicked',
  INVOICE_BREAKDOWN_VIEWED: 'invoice_breakdown_viewed',
  INVOICE_DETAIL_VIEWED: 'invoice_detail_viewed',
  INVOICE_PDF_VIEWED: 'invoice_pdf_viewed',
  INVOICE_RECEIPT_VIEWED: 'invoice_receipt_viewed',
  INVOICE_WORKSHEET_VIEWED: 'invoice_worksheet_viewed',
  INVOICE_NOTES_VIEWED: 'invoice_notes_viewed',
  INVOICE_APPROVAL_STATUS_VIEWED: 'invoice_approval_status_viewed',
  INVOICE_APPROVED: 'invoice_approved',
  INVOICE_PAY_INITIATED: 'invoice_pay_initiated',
  INVOICE_QUERY_RAISED: 'invoice_query_raised',

  // Chat
  CHAT_PAGE_VIEW: 'chat_page_view',
  CHAT_VIEWED: 'chat_viewed',
  CHAT_CREATED: 'chat_created',
  CHAT_CREATED_FROM_BANNER: 'chat_created_from_banner',
  GROUP_CHAT_CREATED: 'group_chat_created',
  MESSAGE_SENT: 'message_sent',
  // Order Invoices (invoices viewed from within an order)
  ORDER_INVOICE_LISTING_PAGE_VIEW: 'order_invoice_listing_page_view',
  ORDER_INVOICE_TAB_SWITCHED: 'order_invoice_tab_switched',
  ORDER_INVOICE_DETAIL_VIEWED: 'order_invoice_detail_viewed',
  ORDER_INVOICE_PDF_VIEWED: 'order_invoice_pdf_viewed',
  ORDER_INVOICE_RECEIPT_VIEWED: 'order_invoice_receipt_viewed',
  ORDER_INVOICE_WORKSHEET_VIEWED: 'order_invoice_worksheet_viewed',
  ORDER_INVOICE_NOTES_VIEWED: 'order_invoice_notes_viewed',
  ORDER_INVOICE_APPROVAL_STATUS_VIEWED: 'order_invoice_approval_status_viewed',
  ORDER_INVOICE_APPROVED: 'order_invoice_approved',
  ORDER_INVOICE_PAY_INITIATED: 'order_invoice_pay_initiated',
  ORDER_INVOICE_QUERY_RAISED: 'order_invoice_query_raised',

  // Invoice Worksheet
  INVOICE_WORKSHEET_PAGE_VIEW: 'invoice_worksheet_page_view',
  INVOICE_WORKSHEET_SHIFT_EXPANDED: 'invoice_worksheet_shift_expanded',
  INVOICE_WORKSHEET_SHIFT_NOTES_VIEWED: 'invoice_worksheet_shift_notes_viewed',

  // Payment History
  PAYMENT_HISTORY_PAGE_VIEW: 'payment_history_page_view',
  PAYMENT_HISTORY_ORDER_LINK_CLICKED: 'payment_history_order_link_clicked',
  PAYMENT_HISTORY_INVOICE_LINK_CLICKED: 'payment_history_invoice_link_clicked',

  // Return Requests
  RETURN_REQUEST_LIST_PAGE_VIEW: 'return_request_list_page_view',
  RETURN_REQUEST_TAB_SWITCHED: 'return_request_tab_switched',
  RETURN_REQUEST_DETAIL_VIEWED: 'return_request_detail_viewed',
  RETURN_REQUEST_VIEW_INVOICES_CLICKED: 'return_request_view_invoices_clicked',
  RETURN_REQUEST_REPORT_PROBLEM_OPENED: 'return_request_report_problem_opened',
  RETURN_REQUEST_ADD_COMMENT_OPENED: 'return_request_add_comment_opened',
  RETURN_REQUEST_ORDER_APPROVED: 'return_request_order_approved',
  RETURN_REQUEST_ORDER_REJECTED: 'return_request_order_rejected',
  RETURN_REQUEST_PAY_INITIATED: 'return_request_pay_initiated',
  RETURN_REQUEST_ITEM_CANCEL_CONFIRMED: 'return_request_item_cancel_confirmed',
  RETURN_REQUEST_CANCEL_SUBMITTED: 'return_request_cancel_submitted',

  // Profile
  PROFILE_PAGE_VIEW: 'profile_page_view',
  PROFILE_EDIT_PROFILE_OPENED: 'profile_edit_profile_opened',
  PROFILE_MANAGE_ACH_OPENED: 'profile_manage_ach_opened',
  PROFILE_MANAGE_CARDS_OPENED: 'profile_manage_cards_opened',
  PROFILE_DEACTIVATE_MODAL_OPENED: 'profile_deactivate_modal_opened',
  PROFILE_DEACTIVATE_CONFIRMED: 'profile_deactivate_confirmed',
  PROFILE_EDIT_PROFESSIONAL_DETAILS_OPENED:
    'profile_edit_professional_details_opened',
  PROFILE_LEAVE_ENTITY_INITIATED: 'profile_leave_entity_initiated',
  PROFILE_LEAVE_ENTITY_CONFIRMED: 'profile_leave_entity_confirmed',
  PROFILE_VIEW_ALL_CLICKED: 'profile_view_all_clicked',
  PROFILE_UPDATED: 'profile_updated',
  PROFILE_PROFESSIONAL_DETAILS_UPDATED: 'profile_professional_details_updated',
  PROFILE_SAVED_CARD_ADD_INITIATED: 'profile_saved_card_add_initiated',
  PROFILE_SAVED_CARD_ADDED: 'profile_saved_card_added',
  PROFILE_SAVED_CARD_DELETED: 'profile_saved_card_deleted',
  PROFILE_SAVED_ACH_ADD_INITIATED: 'profile_saved_ach_add_initiated',
  PROFILE_SAVED_ACH_ADDED: 'profile_saved_ach_added',
  PROFILE_SAVED_ACH_DELETED: 'profile_saved_ach_deleted',
  PROFILE_ACCESS_LIST_PAGE_VIEW: 'profile_access_list_page_view',
  PROFILE_VIEW_ACCESS_PAGE_VIEW: 'profile_view_access_page_view',

  // Dashboard - Studio
  DASHBOARD_STUDIO_PAGE_VIEW: 'dashboard_studio_page_view',
  DASHBOARD_STUDIO_TAB_SWITCHED: 'dashboard_studio_tab_switched',
  DASHBOARD_STUDIO_COUNT_CARD_CLICKED: 'dashboard_studio_count_card_clicked',
  DASHBOARD_STUDIO_GRAPH_FILTER_CHANGED:
    'dashboard_studio_graph_filter_changed',
  DASHBOARD_STUDIO_PRODUCTION_CLICKED: 'dashboard_studio_production_clicked',

  // Dashboard - Production
  DASHBOARD_PRODUCTION_PAGE_VIEW: 'dashboard_production_page_view',
  DASHBOARD_PRODUCTION_TAB_SWITCHED: 'dashboard_production_tab_switched',
  DASHBOARD_PRODUCTION_COUNT_CARD_CLICKED:
    'dashboard_production_count_card_clicked',
  DASHBOARD_PRODUCTION_GRAPH_FILTER_CHANGED:
    'dashboard_production_graph_filter_changed',
  DASHBOARD_PRODUCTION_SPENDING_DETAIL_CLICKED:
    'dashboard_production_spending_detail_clicked',
  DASHBOARD_PRODUCTION_CHILD_CLICKED: 'dashboard_production_child_clicked',

  // Dashboard - Episode
  DASHBOARD_EPISODE_PAGE_VIEW: 'dashboard_episode_page_view',
  DASHBOARD_EPISODE_TAB_SWITCHED: 'dashboard_episode_tab_switched',
  DASHBOARD_EPISODE_COUNT_CARD_CLICKED: 'dashboard_episode_count_card_clicked',
  DASHBOARD_EPISODE_GRAPH_FILTER_CHANGED:
    'dashboard_episode_graph_filter_changed',
  DASHBOARD_EPISODE_SPENDING_DETAIL_CLICKED:
    'dashboard_episode_spending_detail_clicked',
  DASHBOARD_EPISODE_CHILD_CLICKED: 'dashboard_episode_child_clicked',

  // Dashboard - Set
  DASHBOARD_SET_PAGE_VIEW: 'dashboard_set_page_view',
  DASHBOARD_SET_COUNT_CARD_CLICKED: 'dashboard_set_count_card_clicked',
  DASHBOARD_SET_GRAPH_FILTER_CHANGED: 'dashboard_set_graph_filter_changed',
  DASHBOARD_SET_SPENDING_DETAIL_CLICKED:
    'dashboard_set_spending_detail_clicked',
  DASHBOARD_SET_LOCATION_CLICKED: 'dashboard_set_location_clicked',

  // Dashboard - Location
  DASHBOARD_LOCATION_PAGE_VIEW: 'dashboard_location_page_view',
  DASHBOARD_LOCATION_TAB_SWITCHED: 'dashboard_location_tab_switched',
  DASHBOARD_LOCATION_COUNT_CARD_CLICKED:
    'dashboard_location_count_card_clicked',
  DASHBOARD_LOCATION_GRAPH_FILTER_CHANGED:
    'dashboard_location_graph_filter_changed',
  DASHBOARD_LOCATION_SPENDING_DETAIL_CLICKED:
    'dashboard_location_spending_detail_clicked',
  DASHBOARD_LOCATION_SET_CLICKED: 'dashboard_location_set_clicked',

  // Dashboard - Production Detail
  DASHBOARD_PRODUCTION_DETAIL_PAGE_VIEW:
    'dashboard_production_detail_page_view',
  DASHBOARD_PRODUCTION_DETAIL_EDIT_CLICKED:
    'dashboard_production_detail_edit_clicked',
  DASHBOARD_PRODUCTION_DETAIL_SPENDING_CLICKED:
    'dashboard_production_detail_spending_clicked',
  DASHBOARD_PRODUCTION_DETAIL_CONTACT_ADDED:
    'dashboard_production_detail_contact_added',

  // Order Settings
  ORDER_SETTINGS_PAGE_VIEW: 'order_settings_page_view',
  ORDER_SETTINGS_APPROVAL_LEVEL_SELECTED:
    'order_settings_approval_level_selected',
  ORDER_SETTINGS_APPROVER_LEVEL_MODAL_OPENED:
    'order_settings_approver_level_modal_opened',
  ORDER_SETTINGS_APPROVERS_SUBMITTED: 'order_settings_approvers_submitted',
  ORDER_SETTINGS_ADD_MEMBER_CLICKED: 'order_settings_add_member_clicked',
  ORDER_SETTINGS_ADD_CREW_PAGE_VIEW: 'order_settings_add_crew_page_view',
  ORDER_SETTINGS_ADD_CREW_TAB_SWITCHED: 'order_settings_add_crew_tab_switched',
  ORDER_SETTINGS_CREW_MEMBER_ADDED: 'order_settings_crew_member_added',

  // MyOrders - Order Detail
  ORDER_DETAIL_PAGE_VIEW: 'order_detail_page_view',
  ORDER_DETAIL_VIEW_INVOICES_CLICKED: 'order_detail_view_invoices_clicked',
  ORDER_DETAIL_VIEW_PAYMENT_HISTORY_CLICKED:
    'order_detail_view_payment_history_clicked',
  ORDER_DETAIL_REPORT_PROBLEM_OPENED: 'order_detail_report_problem_opened',
  ORDER_DETAIL_ADD_COMMENT_OPENED: 'order_detail_add_comment_opened',
  ORDER_DETAIL_ORDER_APPROVED: 'order_detail_order_approved',
  ORDER_DETAIL_ORDER_REJECTED: 'order_detail_order_rejected',
  ORDER_DETAIL_VENDOR_APPROVED: 'order_detail_vendor_approved',
  ORDER_DETAIL_VENDOR_REJECTED: 'order_detail_vendor_rejected',
  ORDER_DETAIL_PAY_INITIATED: 'order_detail_pay_initiated',

  // MyOrders - Order Request
  ORDER_REQUEST_PAGE_VIEW: 'order_request_page_view',
  ORDER_REQUEST_TAB_SWITCHED: 'order_request_tab_switched',

  // MyOrders - Vendor Requests
  VENDOR_REQUEST_PAGE_VIEW: 'vendor_request_page_view',
  VENDOR_REQUEST_TAB_SWITCHED: 'vendor_request_tab_switched',

  // MyOrders - Preview Shifts
  PREVIEW_SHIFTS_PAGE_VIEW: 'preview_shifts_page_view',
  PREVIEW_SHIFTS_CANCEL_CONFIRMED: 'preview_shifts_cancel_confirmed',

  // MyOrders - Updated Shifts
  UPDATED_SHIFTS_PAGE_VIEW: 'updated_shifts_page_view',
  UPDATED_SHIFTS_APPROVED: 'updated_shifts_approved',
  UPDATED_SHIFTS_REJECTED: 'updated_shifts_rejected',

  // Scheduler
  SCHEDULER_PAGE_VIEW: 'scheduler_page_view',
  SCHEDULER_DATE_CLICKED: 'scheduler_date_clicked',
  SCHEDULER_FILTER_APPLIED: 'scheduler_filter_applied',
  SCHEDULER_FILTER_RESET: 'scheduler_filter_reset',
  SCHEDULER_ITEM_CLICKED: 'scheduler_item_clicked',

  // Spendings - Studio
  SPENDING_STUDIO_PAGE_VIEW: 'spending_studio_page_view',
  SPENDING_STUDIO_GRAPH_FILTER_CHANGED: 'spending_studio_graph_filter_changed',

  // Spendings - Production
  SPENDING_PRODUCTION_PAGE_VIEW: 'spending_production_page_view',
  SPENDING_PRODUCTION_GRAPH_FILTER_CHANGED:
    'spending_production_graph_filter_changed',

  // Spendings - Episode
  SPENDING_EPISODE_PAGE_VIEW: 'spending_episode_page_view',
  SPENDING_EPISODE_GRAPH_FILTER_CHANGED:
    'spending_episode_graph_filter_changed',

  // Spendings - Set
  SPENDING_SET_PAGE_VIEW: 'spending_set_page_view',
  SPENDING_SET_GRAPH_FILTER_CHANGED: 'spending_set_graph_filter_changed',

  // Spendings - Department
  SPENDING_DEPARTMENT_PAGE_VIEW: 'spending_department_page_view',
  SPENDING_DEPARTMENT_GRAPH_FILTER_CHANGED:
    'spending_department_graph_filter_changed',

  // Spendings - Location
  SPENDING_LOCATION_PAGE_VIEW: 'spending_location_page_view',
  SPENDING_LOCATION_GRAPH_FILTER_CHANGED:
    'spending_location_graph_filter_changed',

  // Search
  SEARCH_PERFORMED: 'search_performed',

  // Error
  API_ERROR: 'api_error',
} as const;

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export interface AnalyticsEventParams {
  [ANALYTICS_EVENTS.LOGIN]: { method?: string };
  [ANALYTICS_EVENTS.LOGOUT]: Record<string, never>;
  [ANALYTICS_EVENTS.SIGN_UP]: { method?: string };

  [ANALYTICS_EVENTS.PAGE_VIEW]: { page_path: string; page_title?: string };

  [ANALYTICS_EVENTS.STUDIO_CREATED]: {
    studio_id?: string;
    studio_name?: string;
  };
  [ANALYTICS_EVENTS.STUDIO_UPDATED]: { studio_id?: string };
  [ANALYTICS_EVENTS.STUDIO_DELETED]: { studio_id?: string };

  [ANALYTICS_EVENTS.PRODUCTION_CREATED]: {
    production_id?: string;
    studio_id?: string;
  };
  [ANALYTICS_EVENTS.PRODUCTION_UPDATED]: { production_id?: string };
  [ANALYTICS_EVENTS.PRODUCTION_DELETED]: { production_id?: string };

  [ANALYTICS_EVENTS.EPISODE_CREATED]: {
    episode_id?: string;
    production_id?: string;
  };
  [ANALYTICS_EVENTS.EPISODE_UPDATED]: { episode_id?: string };
  [ANALYTICS_EVENTS.EPISODE_DELETED]: { episode_id?: string };

  [ANALYTICS_EVENTS.SET_CREATED]: { set_id?: string; episode_id?: string };
  [ANALYTICS_EVENTS.SET_UPDATED]: { set_id?: string };
  [ANALYTICS_EVENTS.SET_DELETED]: { set_id?: string };

  [ANALYTICS_EVENTS.LOCATION_CREATED]: {
    location_id?: string;
    set_id?: string;
  };
  [ANALYTICS_EVENTS.LOCATION_UPDATED]: { location_id?: string };
  [ANALYTICS_EVENTS.LOCATION_DELETED]: { location_id?: string };

  [ANALYTICS_EVENTS.DEPARTMENT_CREATED]: {
    entity_type?: string;
    entity_id?: string;
  };

  [ANALYTICS_EVENTS.STORE_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.ORDERS_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.VENDOR_DETAIL_VIEW]: {
    vendor_id?: string;
    vendor_name?: string;
  };
  [ANALYTICS_EVENTS.PRODUCT_DETAIL_VIEW]: {
    product_id?: string;
    product_name?: string;
  };
  [ANALYTICS_EVENTS.PACKAGE_DETAIL_VIEW]: {
    package_id?: string;
    package_name?: string;
  };
  [ANALYTICS_EVENTS.SERVICE_DETAIL_VIEW]: {
    service_id?: string;
    service_name?: string;
  };

  [ANALYTICS_EVENTS.ADD_TO_CART]: {
    product_id?: string;
    product_name?: string;
    product_type?: string;
  };
  [ANALYTICS_EVENTS.PREVIEW_SHIFT]: {
    product_id?: string;
    product_name?: string;
  };
  [ANALYTICS_EVENTS.CART_QUANTITY_UPDATED]: { cart_id?: string };
  [ANALYTICS_EVENTS.CART_LOCATION_UPDATED]: Record<string, never>;
  [ANALYTICS_EVENTS.CART_SHIFT_UPDATED]: Record<string, never>;
  [ANALYTICS_EVENTS.CART_ADD_MORE_ITEMS]: Record<string, never>;

  [ANALYTICS_EVENTS.ORDER_PLACED]: {
    order_id?: string;
    amount?: number;
    currency?: string;
  };
  [ANALYTICS_EVENTS.ORDER_CANCELLED]: { order_id?: string; reason?: string };
  [ANALYTICS_EVENTS.ORDER_SHIFTS_CANCELLED]: {
    shift_count?: number;
    shift_ids?: string;
  };
  [ANALYTICS_EVENTS.ORDER_RETURNED]: { order_id?: string; reason?: string };
  [ANALYTICS_EVENTS.ORDER_SHIFT_UPDATED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_ADD_MORE_ITEMS]: { order_id?: string };

  [ANALYTICS_EVENTS.PAYMENT_SUCCESS]: {
    order_id?: string;
    amount?: number;
    payment_type?: string;
  };
  [ANALYTICS_EVENTS.PAYMENT_FAILED]: { message?: string };

  [ANALYTICS_EVENTS.DOCUMENT_UPLOADED]: {
    doc_type?: string;
    entity_type?: string;
  };
  [ANALYTICS_EVENTS.DOCUMENT_DOWNLOADED]: { doc_type?: string };
  [ANALYTICS_EVENTS.DOCUMENT_DELETED]: { doc_type?: string };

  [ANALYTICS_EVENTS.RISK_DASHBOARD_VIEW]: {
    entity_type?: string;
    entity_id?: string;
  };
  [ANALYTICS_EVENTS.RISK_FORM_SUBMITTED]: {
    form_type?: string;
    production_id?: string;
  };
  [ANALYTICS_EVENTS.RISK_THREAT_DETAIL_VIEW]: { threat_id?: string };
  [ANALYTICS_EVENTS.RISK_PDF_EXPORTED]: { threat_id?: string };

  [ANALYTICS_EVENTS.CONTACT_INVITED]: { entity_type?: string; role?: string };
  [ANALYTICS_EVENTS.CONTACT_REMOVED]: { entity_type?: string };

  [ANALYTICS_EVENTS.INVOICE_LISTING_PAGE_VIEW]: {
    entity_type?: string;
    entity_id?: string;
    tab?: string;
  };
  [ANALYTICS_EVENTS.INVOICE_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.INVOICE_REQUESTS_PAGE_VIEW]: { tab?: string };
  [ANALYTICS_EVENTS.INVOICE_REQUESTS_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.INVOICE_CARD_CLICKED]: {
    invoice_id?: string;
    payment_status?: string;
  };
  [ANALYTICS_EVENTS.INVOICE_BREAKDOWN_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.INVOICE_DETAIL_VIEWED]: {
    invoice_id?: string;
    invoice_type?: string;
    payment_status?: string;
  };
  [ANALYTICS_EVENTS.INVOICE_PDF_VIEWED]: {
    invoice_id?: string;
    invoice_type?: string;
  };
  [ANALYTICS_EVENTS.INVOICE_RECEIPT_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.INVOICE_WORKSHEET_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.INVOICE_NOTES_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.INVOICE_APPROVAL_STATUS_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.INVOICE_APPROVED]: {
    invoice_id?: string;
    amount?: number;
  };
  [ANALYTICS_EVENTS.INVOICE_PAY_INITIATED]: {
    invoice_id?: string;
    amount?: number;
  };
  [ANALYTICS_EVENTS.INVOICE_QUERY_RAISED]: { invoice_id?: string };

  [ANALYTICS_EVENTS.CHAT_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.CHAT_VIEWED]: {
    chat_id?: string;
    chat_type?: string;
    contact_name?: string;
  };
  [ANALYTICS_EVENTS.CHAT_CREATED]: {
    chat_id?: string;
    chat_type?: string;
    contact_id?: string;
    contact_name?: string;
    source?: string;
  };
  [ANALYTICS_EVENTS.CHAT_CREATED_FROM_BANNER]: {
    chat_id?: string;
    contact_id?: string;
    contact_name?: string;
    source?: string;
  };
  [ANALYTICS_EVENTS.GROUP_CHAT_CREATED]: {
    group_id?: string;
    group_name?: string;
    member_count?: number;
    entity_type?: string;
    entity_id?: string;
  };
  [ANALYTICS_EVENTS.MESSAGE_SENT]: {
    chat_id?: string;
    chat_type?: string;
    message_type?: string;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_LISTING_PAGE_VIEW]: {
    vendor_order_id?: string;
    tab?: string;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.ORDER_INVOICE_DETAIL_VIEWED]: {
    invoice_id?: string;
    invoice_type?: string;
    payment_status?: string;
    vendor_order_id?: string;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_PDF_VIEWED]: {
    invoice_id?: string;
    invoice_type?: string;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_RECEIPT_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.ORDER_INVOICE_WORKSHEET_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.ORDER_INVOICE_NOTES_VIEWED]: { invoice_id?: string };
  [ANALYTICS_EVENTS.ORDER_INVOICE_APPROVAL_STATUS_VIEWED]: {
    invoice_id?: string;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_APPROVED]: {
    invoice_id?: string;
    amount?: number;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_PAY_INITIATED]: {
    invoice_id?: string;
    amount?: number;
  };
  [ANALYTICS_EVENTS.ORDER_INVOICE_QUERY_RAISED]: { invoice_id?: string };

  [ANALYTICS_EVENTS.INVOICE_WORKSHEET_PAGE_VIEW]: {
    invoice_id?: string;
    production_name?: string;
  };
  [ANALYTICS_EVENTS.INVOICE_WORKSHEET_SHIFT_EXPANDED]: {
    invoice_id?: string;
    shift_type?: string;
    date?: string;
  };
  [ANALYTICS_EVENTS.INVOICE_WORKSHEET_SHIFT_NOTES_VIEWED]: {
    shift_id?: string;
    invoice_id?: string;
  };

  [ANALYTICS_EVENTS.PAYMENT_HISTORY_PAGE_VIEW]: {
    entity_type?: string;
    entity_id?: string;
  };
  [ANALYTICS_EVENTS.PAYMENT_HISTORY_ORDER_LINK_CLICKED]: {
    order_id?: string;
    payment_status?: string;
    amount?: number;
  };
  [ANALYTICS_EVENTS.PAYMENT_HISTORY_INVOICE_LINK_CLICKED]: {
    invoice_id?: string;
    payment_status?: string;
    amount?: number;
  };

  [ANALYTICS_EVENTS.RETURN_REQUEST_LIST_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.RETURN_REQUEST_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.RETURN_REQUEST_DETAIL_VIEWED]: {
    order_id?: string;
    return_status?: string;
  };
  [ANALYTICS_EVENTS.RETURN_REQUEST_VIEW_INVOICES_CLICKED]: {
    order_id?: string;
  };
  [ANALYTICS_EVENTS.RETURN_REQUEST_REPORT_PROBLEM_OPENED]: {
    order_id?: string;
  };
  [ANALYTICS_EVENTS.RETURN_REQUEST_ADD_COMMENT_OPENED]: { order_id?: string };
  [ANALYTICS_EVENTS.RETURN_REQUEST_ORDER_APPROVED]: { order_id?: string };
  [ANALYTICS_EVENTS.RETURN_REQUEST_ORDER_REJECTED]: { order_id?: string };
  [ANALYTICS_EVENTS.RETURN_REQUEST_PAY_INITIATED]: {
    order_id?: string;
    amount?: number;
  };
  [ANALYTICS_EVENTS.RETURN_REQUEST_ITEM_CANCEL_CONFIRMED]: {
    item_id?: string;
    order_id?: string;
  };
  [ANALYTICS_EVENTS.RETURN_REQUEST_CANCEL_SUBMITTED]: {
    item_count?: number;
  };

  [ANALYTICS_EVENTS.PROFILE_PAGE_VIEW]: {
    is_own_profile?: boolean;
    user_id?: string;
  };
  [ANALYTICS_EVENTS.PROFILE_EDIT_PROFILE_OPENED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_MANAGE_ACH_OPENED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_MANAGE_CARDS_OPENED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_DEACTIVATE_MODAL_OPENED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_DEACTIVATE_CONFIRMED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_EDIT_PROFESSIONAL_DETAILS_OPENED]: Record<
    string,
    never
  >;
  [ANALYTICS_EVENTS.PROFILE_LEAVE_ENTITY_INITIATED]: {
    entity_type?: string;
    entity_label?: string;
  };
  [ANALYTICS_EVENTS.PROFILE_LEAVE_ENTITY_CONFIRMED]: {
    entity_type?: string;
    entity_id?: string;
  };
  [ANALYTICS_EVENTS.PROFILE_VIEW_ALL_CLICKED]: { user_id?: string };
  [ANALYTICS_EVENTS.PROFILE_UPDATED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_PROFESSIONAL_DETAILS_UPDATED]: Record<
    string,
    never
  >;
  [ANALYTICS_EVENTS.PROFILE_SAVED_CARD_ADD_INITIATED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_SAVED_CARD_ADDED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_SAVED_CARD_DELETED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_SAVED_ACH_ADD_INITIATED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_SAVED_ACH_ADDED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_SAVED_ACH_DELETED]: Record<string, never>;
  [ANALYTICS_EVENTS.PROFILE_ACCESS_LIST_PAGE_VIEW]: { user_id?: string };
  [ANALYTICS_EVENTS.PROFILE_VIEW_ACCESS_PAGE_VIEW]: {
    entity_id?: string;
    module?: string;
    user_id?: string;
  };

  [ANALYTICS_EVENTS.DASHBOARD_STUDIO_PAGE_VIEW]: {
    studio_id?: string;
    studio_name?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_STUDIO_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.DASHBOARD_STUDIO_COUNT_CARD_CLICKED]: { card_type: string };
  [ANALYTICS_EVENTS.DASHBOARD_STUDIO_GRAPH_FILTER_CHANGED]: {
    filter_type?: string;
    filter_value?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_STUDIO_PRODUCTION_CLICKED]: {
    production_id?: string;
  };

  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_PAGE_VIEW]: {
    production_id?: string;
    production_name?: string;
    production_type?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_COUNT_CARD_CLICKED]: {
    card_type: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_SPENDING_DETAIL_CLICKED]: {
    production_id?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_CHILD_CLICKED]: {
    child_type?: string;
    child_id?: string;
  };

  [ANALYTICS_EVENTS.DASHBOARD_EPISODE_PAGE_VIEW]: {
    episode_id?: string;
    episode_name?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_EPISODE_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.DASHBOARD_EPISODE_COUNT_CARD_CLICKED]: {
    card_type: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_EPISODE_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_EPISODE_SPENDING_DETAIL_CLICKED]: {
    episode_id?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_EPISODE_CHILD_CLICKED]: {
    child_type?: string;
    child_id?: string;
  };

  [ANALYTICS_EVENTS.DASHBOARD_SET_PAGE_VIEW]: {
    set_id?: string;
    set_name?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_SET_COUNT_CARD_CLICKED]: { card_type: string };
  [ANALYTICS_EVENTS.DASHBOARD_SET_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_SET_SPENDING_DETAIL_CLICKED]: {
    set_id?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_SET_LOCATION_CLICKED]: { location_id?: string };

  [ANALYTICS_EVENTS.DASHBOARD_LOCATION_PAGE_VIEW]: {
    location_id?: string;
    location_name?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_LOCATION_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.DASHBOARD_LOCATION_COUNT_CARD_CLICKED]: {
    card_type: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_LOCATION_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_LOCATION_SPENDING_DETAIL_CLICKED]: {
    location_id?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_LOCATION_SET_CLICKED]: {
    set_id?: string;
    set_type?: string;
  };

  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_DETAIL_PAGE_VIEW]: {
    production_id?: string;
    production_type?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_DETAIL_EDIT_CLICKED]: {
    production_id?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_DETAIL_SPENDING_CLICKED]: {
    production_id?: string;
  };
  [ANALYTICS_EVENTS.DASHBOARD_PRODUCTION_DETAIL_CONTACT_ADDED]: {
    member_type?: string;
  };

  [ANALYTICS_EVENTS.ORDER_SETTINGS_PAGE_VIEW]: { production_id?: string };
  [ANALYTICS_EVENTS.ORDER_SETTINGS_APPROVAL_LEVEL_SELECTED]: {
    level_name?: string;
  };
  [ANALYTICS_EVENTS.ORDER_SETTINGS_APPROVER_LEVEL_MODAL_OPENED]: Record<
    string,
    never
  >;
  [ANALYTICS_EVENTS.ORDER_SETTINGS_APPROVERS_SUBMITTED]: {
    production_id?: string;
    role_id?: string;
  };
  [ANALYTICS_EVENTS.ORDER_SETTINGS_ADD_MEMBER_CLICKED]: Record<string, never>;
  [ANALYTICS_EVENTS.ORDER_SETTINGS_ADD_CREW_PAGE_VIEW]: {
    production_id?: string;
  };
  [ANALYTICS_EVENTS.ORDER_SETTINGS_ADD_CREW_TAB_SWITCHED]: { tab: string };
  [ANALYTICS_EVENTS.ORDER_SETTINGS_CREW_MEMBER_ADDED]: {
    production_id?: string;
  };

  [ANALYTICS_EVENTS.ORDER_DETAIL_PAGE_VIEW]: {
    order_id?: string;
    order_type?: string;
  };
  [ANALYTICS_EVENTS.ORDER_DETAIL_VIEW_INVOICES_CLICKED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_VIEW_PAYMENT_HISTORY_CLICKED]: {
    order_id?: string;
  };
  [ANALYTICS_EVENTS.ORDER_DETAIL_REPORT_PROBLEM_OPENED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_ADD_COMMENT_OPENED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_ORDER_APPROVED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_ORDER_REJECTED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_VENDOR_APPROVED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_VENDOR_REJECTED]: { order_id?: string };
  [ANALYTICS_EVENTS.ORDER_DETAIL_PAY_INITIATED]: {
    order_id?: string;
    amount?: number;
  };

  [ANALYTICS_EVENTS.ORDER_REQUEST_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.ORDER_REQUEST_TAB_SWITCHED]: { tab: string };

  [ANALYTICS_EVENTS.VENDOR_REQUEST_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.VENDOR_REQUEST_TAB_SWITCHED]: { tab: string };

  [ANALYTICS_EVENTS.PREVIEW_SHIFTS_PAGE_VIEW]: { order_id?: string };
  [ANALYTICS_EVENTS.PREVIEW_SHIFTS_CANCEL_CONFIRMED]: {
    order_id?: string;
    shift_count?: number;
  };

  [ANALYTICS_EVENTS.UPDATED_SHIFTS_PAGE_VIEW]: { order_id?: string };
  [ANALYTICS_EVENTS.UPDATED_SHIFTS_APPROVED]: {
    order_id?: string;
    shift_count?: number;
  };
  [ANALYTICS_EVENTS.UPDATED_SHIFTS_REJECTED]: {
    order_id?: string;
    shift_count?: number;
  };

  [ANALYTICS_EVENTS.SCHEDULER_PAGE_VIEW]: Record<string, never>;
  [ANALYTICS_EVENTS.SCHEDULER_DATE_CLICKED]: { date?: string };
  [ANALYTICS_EVENTS.SCHEDULER_FILTER_APPLIED]: { filter_count?: number };
  [ANALYTICS_EVENTS.SCHEDULER_FILTER_RESET]: Record<string, never>;
  [ANALYTICS_EVENTS.SCHEDULER_ITEM_CLICKED]: {
    item_type?: string;
    item_id?: string;
  };

  [ANALYTICS_EVENTS.SPENDING_STUDIO_PAGE_VIEW]: {
    studio_id?: string;
    entity_type?: string;
  };
  [ANALYTICS_EVENTS.SPENDING_STUDIO_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };

  [ANALYTICS_EVENTS.SPENDING_PRODUCTION_PAGE_VIEW]: {
    production_id?: string;
    production_type?: string;
  };
  [ANALYTICS_EVENTS.SPENDING_PRODUCTION_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };

  [ANALYTICS_EVENTS.SPENDING_EPISODE_PAGE_VIEW]: {
    episode_id?: string;
    production_id?: string;
  };
  [ANALYTICS_EVENTS.SPENDING_EPISODE_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };

  [ANALYTICS_EVENTS.SPENDING_SET_PAGE_VIEW]: {
    set_id?: string;
    production_id?: string;
  };
  [ANALYTICS_EVENTS.SPENDING_SET_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };

  [ANALYTICS_EVENTS.SPENDING_DEPARTMENT_PAGE_VIEW]: {
    department_id?: string;
    production_id?: string;
  };
  [ANALYTICS_EVENTS.SPENDING_DEPARTMENT_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };

  [ANALYTICS_EVENTS.SPENDING_LOCATION_PAGE_VIEW]: {
    location_id?: string;
    production_id?: string;
  };
  [ANALYTICS_EVENTS.SPENDING_LOCATION_GRAPH_FILTER_CHANGED]: {
    filter_value?: string;
  };

  [ANALYTICS_EVENTS.SEARCH_PERFORMED]: { query?: string; section?: string };

  [ANALYTICS_EVENTS.API_ERROR]: {
    endpoint?: string;
    status_code?: number;
    message?: string;
  };
}
